import Vue from "vue";
import Vuex, { Store } from "vuex";

Vue.use(Vuex);

const store: Store<any> = new Vuex.Store({});

export default store;
